'use strict';

import moment from 'moment-timezone';

angular.module('docketbook').
  controller('newOrgModalController', function(userService, billingService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

    $scope.$parent.createNewCompanyFromParent = function(isSampleCompany, successCb) {

		if (!isSampleCompany) {
			window.location.href = '/onboarding/new'
			return
		}

		$scope.newCompanyCallback = successCb;
      	$scope.newCompany = {};
  		$scope.newCompany.currentStep = 1;
  		$scope.newCompany.stepCount = 3;
  		$scope.newCompany.process = 'form';
  		$scope.newCompany.helpMethodStep = 'select';
  		$scope.newCompany.showFullAddress = false;
  		var timezone = moment.tz.guess();
  		if ( timezone ) {
  			$scope.newCompany.timezone = timezone;
		}
		$("#editOrgModal").fadeIn(100);
		if (isSampleCompany === true) {
			return $scope.performSampleCompany();
		}
	}

	$scope.performSampleCompany = function() {
		$scope.newCompany.process = 'creating';
		const postObj = {
			name: "Sample Company",
			isSampleCompany: true
		};
		userService.createNewOrganisation(postObj, function(org) {
			$scope.newCompany.orgCreated = org;
			accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
				$scope.newCompanyCallback($scope.newCompany.orgCreated);
			}, function(err){
				$scope.newCompanyCallback($scope.newCompany.orgCreated);
			});
		}, function(err) {
			$scope.alertService.presentAutoAlert('createSampleCompany', err);
			$("#editOrgModal").fadeOut(100);
		})
	}

    $scope.closeOrgEditModal = function() {
  		$("#editOrgModal").fadeOut(100);
      $scope.newCompanyCallback(null);
  	}

    $scope.newCompanyNext = function() {
  		$scope.newCompany.currentStep += 1;
  		$timeout(function() {
  			$("#editOrgFormStep" + $scope.newCompany.currentStep + " input:enabled:visible:first").focus();
  		}, 200);
  	}

    $scope.newCompanyBack = function() {
  		$scope.newCompany.currentStep -= 1;
  	}

  	$scope.newCompanyManualAddress = function() {
  		$scope.newCompany.showFullAddress = !$scope.newCompany.showFullAddress;
  	}

  	$scope.$watch('newCompany.address', function() {
  		var requiredFields = ['streetName','suburb','state','postCode','country'];
  		var incorrectFields = [];
  		if ( $scope.newCompany && $scope.newCompany.address ) {
  			for ( var i = 0; i < requiredFields.length; i++ ) {
  				if ( $scope.newCompany.address[requiredFields[i]] == null || $scope.newCompany.address[requiredFields[i]] == "" ) {
  					incorrectFields.push(requiredFields[i]);
  				}
  			}
  			if ( incorrectFields.length > 0 ) {
  				$scope.newCompany.addressAlert = true;
  			} else {
  				$scope.newCompany.addressAlert = false;
  			}
  		}
  	});

  	$scope.createNewCompany = function() {
  		$scope.newCompany.process = 'creating';
  		var postObj = angular.copy($scope.newCompany);
  		postObj.user = $scope.currentUser;
  		userService.createNewOrganisation(postObj, function(org) {
        ga('send', 'event', 'Company', 'created', postObj.name);
        goog_report_conversion();
				// TODO: send update billing information
				var num = $scope.newCompany.contactNumber.replace(/\D/g,'');
  			var contactDetails = {phoneNumber: num};
  			billingService.updateOrganisationBillingContact(org.id, contactDetails, function(success) {
  				$scope.newCompany.process = 'success';
  				$scope.newCompany.orgCreated = org;
  				accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
  				}, function(err){});
  			}, function(err) {
  				$scope.newCompany.process = 'success';
  				$scope.newCompany.orgCreated = org;
  				accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
  				}, function(err){});
  			})
  		}, function(err) {
  			console.log('error creating org', err);
  		});
  	}

  	$scope.newCompanySetupContinue = function(option) {
  		if ( option == 'alone' ) {
        $scope.newCompany.process = 'aloneCongratulations';
  		} else {
  			$scope.newCompany.process = 'selectHelpMethod';
  		}
  	}

    $scope.newCompanySetupAloneFinish = function() {
      $scope.newCompanyCallback($scope.newCompany.orgCreated);
    }

  	$scope.newCompanyHelpMethodSelect = function(option) {
  		/*var supportContact = null;
  		if ( option == 'phone' ) {
  			supportContact = $scope.newCompany.contactNumber;
  		}
  		var update = {
        user_id: $scope.currentUser.id,
        user_hash: $scope.currentUser.hash,
      };
  		update.company = {
  			id: $scope.newCompany.orgCreated.id,
  			name: $scope.newCompany.orgCreated.name,
  			supportMethod: option,
  			supportContact: supportContact
  		};
  		window.Intercom("update", update);*/

      if ( option == 'phone' || option == 'email' ) {
        var contactNumber = '';
        if ( option == 'phone' ) {
          contactNumber = supportContact;
        }
        userService.requestSetupSupport($scope.newCompany.orgCreated.id, option, contactNumber, function() {
          console.log('support request successful');
        }, function() {
          console.log('support request failed');
        });
      }

  		if ( option == 'intercom' ) {
        //$scope.newCompanyCallback($scope.newCompany.orgCreated);
        $scope.newCompany.helpMethodStep = 'confirm';
  		} else if ( option == 'phone' ) {
  			$scope.newCompany.helpMethodStep = 'confirm';
  		} else if ( option == 'email' ) {
  			$scope.newCompany.helpMethodStep = 'confirm';
  		}
  	}

  	$scope.helpMethodFinish = function() {
      $scope.newCompanyCallback($scope.newCompany.orgCreated);
  		//$state.go('main.groupDashboard', {orgId: $scope.newCompany.orgCreated.id});
  	}

  	// Send post request to MAPI to create new org
  	/*$scope.saveOrgEdit = function(orgEdit) {
  		orgEdit.loading = true;
  		var postObj = {};
  		postObj.user = $stateParams.currentUser;
  		postObj.name = orgEdit.name;
  		postObj.address = orgEdit.address;
  		postObj.timezone = orgEdit.timezone;
  		userService.createNewOrganisation(postObj, function(org) {
  			// referesh allowed organisations
  			accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
  				$state.go('main.groupDashboard', {orgId:org.id});
  			}, function(err) {
  				$("#editOrgModal").fadeOut(100);
  			});
  		}, function(err) {
  			orgEdit.loading = false;
  			$scope.alertService.presentAlert("error", "Oops.", "Something went wrong while we were setting up your new organisation. Please try again.");
  		});
  	}*/

});



// WEBPACK FOOTER //
// ./src/controllers/modals/newOrgModalController.js